var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "integralUser seller-style" }, [
    _c("h2", { staticClass: "f18 lin-25 fb normal gray_2" }, [
      _vm._v("商品答疑")
    ]),
    _c("div", { staticClass: "box30" }),
    _c(
      "div",
      [
        _c("div", { staticClass: "flex items-center justify-between" }, [
          _c(
            "div",
            { staticClass: "flex flex1 items-center" },
            [
              _c("el-input", {
                staticClass: "w210 mar20_r",
                attrs: { placeholder: "请输入商品名称关键字" },
                model: {
                  value: _vm.searchForm.spuNameLike,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.searchForm,
                      "spuNameLike",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "searchForm.spuNameLike"
                }
              }),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.searchList } },
                [_vm._v("查询")]
              ),
              _c("el-button", { on: { click: _vm.restList } }, [_vm._v("重置")])
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.toDetail("")
                    }
                  }
                },
                [_vm._v("新增")]
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "box30" }),
        _c(
          "el-table",
          {
            attrs: { border: "", data: _vm.list, "row-class-name": "pointer" },
            on: { "selection-change": _vm.goodsDySelect }
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "selection",
                "reserve-selection": true,
                width: "55"
              }
            }),
            _c("el-table-column", {
              attrs: { prop: "name", label: "商品名称", "min-width": "30%" }
            }),
            _c("el-table-column", {
              attrs: {
                prop: "detailAmount",
                label: "答疑数量",
                "min-width": "15%"
              }
            }),
            _c("el-table-column", {
              attrs: { label: "操作", width: "290" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.toDetail(scope.row.id)
                            }
                          }
                        },
                        [_vm._v("编辑")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.delItem(scope.row.id)
                            }
                          }
                        },
                        [_vm._v("删除")]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "bottom-handle-box" },
          [
            _c(
              "el-button",
              {
                staticClass: "mar-20-l",
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.batchDel()
                  }
                }
              },
              [_vm._v("删除")]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex items-center mar40-t" },
          [
            _c("div", { staticClass: "gray9 flex-auto" }, [
              _vm._v(
                "共 " +
                  _vm._s(_vm.total) +
                  " 条记录 第 " +
                  _vm._s(_vm.current) +
                  " / " +
                  _vm._s(_vm.pages) +
                  " 页"
              )
            ]),
            _c("el-pagination", {
              attrs: {
                layout: "prev, pager, next, sizes, jumper",
                background: "",
                "hide-on-single-page": "",
                "page-size": _vm.size,
                "page-count": _vm.pages,
                "current-page": _vm.current,
                "page-sizes": [10, 50, 100]
              },
              on: {
                "update:pageSize": function($event) {
                  _vm.size = $event
                },
                "update:page-size": function($event) {
                  _vm.size = $event
                },
                "update:currentPage": function($event) {
                  _vm.current = $event
                },
                "update:current-page": function($event) {
                  _vm.current = $event
                },
                "size-change": _vm.sizeChange,
                "current-change": _vm.currentChange
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }